var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTextbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_524",
    "data-name": "Group 524",
    transform: "translate(-984)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_224",
    "data-name": "Rectangle 224",
    width: 24,
    height: 24,
    transform: "translate(984)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1045",
    "data-name": "Group 1045",
    transform: "translate(984.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    d: "M9.172,3.172A4,4,0,0,1,12,2a1,1,0,0,1,0,2,2,2,0,0,0-2,2V18a2,2,0,0,0,2,2,1,1,0,0,1,0,2,4,4,0,0,1-4-4V6A4,4,0,0,1,9.172,3.172Z",
    fill: "#15345a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    d: "M5,3A1,1,0,0,1,6,2a4,4,0,0,1,4,4V18a4,4,0,0,1-4,4,1,1,0,0,1,0-2,2,2,0,0,0,2-2V6A2,2,0,0,0,6,4,1,1,0,0,1,5,3Z",
    fill: "#15345a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    d: "M12,7a1,1,0,0,1,1-1h7a2,2,0,0,1,2,2v8a2,2,0,0,1-2,2H13a1,1,0,0,1,0-2h7V8H13A1,1,0,0,1,12,7Z",
    fill: "#15345a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    d: "M2.586,6.586A2,2,0,0,1,4,6H5A1,1,0,0,1,5,8H4v8H5a1,1,0,0,1,0,2H4a2,2,0,0,1-2-2V8a2,2,0,0,1,.586-1.414Z",
    fill: "#15345a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    d: "M16,12a1,1,0,0,1,1-1h.01a1,1,0,0,1,0,2H17A1,1,0,0,1,16,12Z",
    fill: "#15345a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    "data-name": "Path 182",
    d: "M12,12a1,1,0,0,1,1-1h.01a1,1,0,0,1,0,2H13A1,1,0,0,1,12,12Z",
    fill: "#15345a",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextbox);
export default __webpack_public_path__ + "static/media/textbox.6d9b1af6cf7c3289708440585a3c2e60.svg";
export { ForwardRef as ReactComponent };